import yup, {
    cardNameValidator,
    stringValidator,
    imageValidator,
    booleanValidator,
    integerPositiveValidator,
} from '~/utils/validators.yup';

export const schema = (nullable = false) =>
    yup.object({
        name: cardNameValidator(),
        description: stringValidator.required().max(300),
        image: imageValidator(nullable),
        imageGrid: imageValidator(nullable),
        icon: imageValidator(nullable),
        portraitLeft: imageValidator(nullable),
        portraitRight: imageValidator(nullable),
        fullPortraitLeft: imageValidator(nullable),
        fullPortraitRight: imageValidator(nullable),
        largeFullPortraitLeft: imageValidator(nullable),
        largeFullPortraitRight: imageValidator(nullable),
        decklist: yup
            .array()
            .of(
                yup.object().shape({
                    actionId: yup.string().required(),
                    quantity: integerPositiveValidator,
                    innate: booleanValidator,
                }),
            )
            .required(),
        classBonus: yup.object().shape({
            attackModifiedValue: integerPositiveValidator,
            defenseModifiedValue: integerPositiveValidator,
            healedValue: integerPositiveValidator,
            bonusConditionOption: integerPositiveValidator,
            applyOnce: booleanValidator,
        }),
    });
